/* eslint-disable */
import React, { useContext } from 'react';
import Modal from 'react-responsive-modal';
import privacyData from '../../Helpers/Privacy';
import closeIcon from '../../assets/images/common/close-icon.svg';
import LogoDark from '../../assets/images/logo_dark.svg';
import LogoWhite from '../../assets/images/Logo_light.svg';
import themeSelected from '../Common/Context';

function PolicyPopup(props) {
  const { open, onClose } = props;
  const themeType = useContext(themeSelected);

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <div className="popup_overlay_profile privacyPopup themeChangeLabel">
          <div className="pop-up">
            <div className="privacyLeft">
              <div className="logo footer-pop-logo d-flex align-items-center justify-content-between">
                <img
                  src={themeType.theme === 'dark' ? LogoWhite : LogoDark}
                  alt="logo"
                />
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <p className="policy-header">PRIVACY POLICY</p>
                <img
                  src={closeIcon}
                  className="closeIcon"
                  alt="close"
                  onClick={() => onClose()}
                />
              </div>
              <div className="popupContent">
                <p className="policy-subheader">
                  This privacy policy explains how DICV (collectively
                  “Truckonnect”, “we”, “us” or “our”) collects, use, share and
                  process your information.
                </p>
                {privacyData &&
                  privacyData.data.map(data => {
                    if (data.num <= 7) {
                      return (
                        <div key={data.num}>
                          <p className="policy-level-header">
                            {data.num}){data.title}
                          </p>
                          <p
                            className="policy-subheader"
                            dangerouslySetInnerHTML={{
                              __html: data.info,
                            }}
                          />
                        </div>
                      );
                    }

                    return '';
                  })}
                <div className="privacyRight">
                  {privacyData &&
                    privacyData.data.map(data => {
                      if (data.num > 7) {
                        return (
                          <div key={data.num}>
                            <p className="policy-level-header">
                              {data.num}){data.title}
                            </p>
                            <p
                              className="policy-subheader"
                              dangerouslySetInnerHTML={{
                                __html: data.info,
                              }}
                            />
                          </div>
                        );
                      }

                      return '';
                    })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default PolicyPopup;
